export default __webpack_public_path__ + "static/media/mean-icon.465c52b4.svg";